module.exports = __webpack_public_path__ + "static/img/wulffnet.37a66f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wulffnet.png
// module id = 8eTD
// module chunks = 1